module.exports = __webpack_public_path__ + "img/id.b64ccc79.svg";